import { IHero } from "@src/components/Hero";
import { shimmer, toBase64 } from "@src/utils/shimmer";
import { getCookie } from "cookies-next";
import { useTransform, useScroll, motion } from "framer-motion";
import Image from "next/image";
import React from "react";
import image from "../../../../public/images/image10.png";
import bgImg from "../../../../public/images/t19bg.png";

const Hero: React.FC<IHero> = ({
  eventId,
  heroImageData,
  slugData,
  loading,
  eventUuid,
  sectionImage,
}) => {
  const { scrollY } = useScroll();
  const y1 = useTransform(scrollY, [0, 300], [0, 60]);
  const currentAccessToken = getCookie("tsl") as string;
  const [show, setShow] = React.useState<boolean>(false);

  React.useEffect(() => {
    setShow(true);
  }, []);

  return (
    <div className="w-full h-[100vh] relative overflow-hidden flex flex-col lg:flex-row">
      {/* Text Section - First on mobile, second on desktop */}
      <div className="flex-1 h-1/2 lg:h-full relative order-1 lg:order-2">
        {/* Background image */}
        <div className="absolute inset-0">
          <Image
            src={bgImg}
            alt="background"
            layout="fill"
            className="object-cover object-center"
            onError={(e) => console.log("Background image failed to load:", e)}
            onLoad={() => console.log("Background image loaded successfully")}
          />
        </div>

        <div className="relative z-10 h-full flex flex-col">
          {/* Header */}
          {/* <motion.header
            initial={{ opacity: 0, y: -20 }}
            animate={{
              opacity: 1,
              y: 0,
              transition: {
                duration: 0.8,
                ease: [0.79, 0.14, 0.15, 0.86],
              },
            }}
            className="w-full py-2 lg:py-4 flex flex-col"
          >
            <div className="w-full border-b border-[#FCE2B0] mb-1 lg:mb-2 h-2 lg:h-4"></div>

            <div className="w-full px-4 lg:px-20 flex flex-col sm:flex-row justify-center sm:justify-between items-center border-y border-[#FCE2B0]">
              <motion.div
                initial={{ opacity: 0, x: -20 }}
                animate={{
                  opacity: 1,
                  x: 0,
                  transition: {
                    delay: 0.2,
                    duration: 0.6,
                  },
                }}
                className="text-[#FFF3C1] font-light font-ntFab tracking-[0.1rem] lg:tracking-[0.2rem] my-1 lg:my-2 text-xs md:text-sm lg:text-base uppercase text-center sm:text-left break-words"
              >
                {loading
                  ? "..."
                  : !!slugData?.eventBySlug && !!slugData?.eventBySlug?.hash_tag
                  ? slugData?.eventBySlug?.hash_tag
                  : ""}
              </motion.div>
              <motion.div
                initial={{ opacity: 0, x: 20 }}
                animate={{
                  opacity: 1,
                  x: 0,
                  transition: {
                    delay: 0.2,
                    duration: 0.6,
                  },
                }}
                className="text-[#FCE2B0] font-light font-nib tracking-[0.05rem] lg:tracking-[0.1rem] text-xs md:text-sm lg:text-base my-1 lg:my-2 hidden sm:flex"
              >
                LAGOS, NIGERIA
              </motion.div>
            </div>
          </motion.header> */}

          {/* Main Content */}
          <div className="flex-1 flex flex-col justify-center items-center px-4 lg:px-6">
            <motion.h1
              initial={{ opacity: 0, y: 30 }}
              animate={{
                opacity: 1,
                y: 0,
                transition: {
                  delay: 0.4,
                  duration: 0.8,
                  ease: [0.79, 0.14, 0.15, 0.86],
                },
              }}
              className="text-[#FCE2B0] text-2xl sm:text-3xl md:text-4xl lg:text-6xl xl:text-7xl font-light text-center mb-2 lg:mb-4 font-ntFab"
            >
              {slugData?.eventBySlug?.name}
            </motion.h1>

            <motion.p
              initial={{ opacity: 0, y: 30 }}
              whileInView={{
                opacity: 1,
                y: 0,
                transition: {
                  duration: 1,
                  ease: [0.79, 0.14, 0.15, 0.86],
                },
              }}
              className="font-light font-ebGaramond text-base w-4/5 sm:text-lg md:text-xl lg:text-[1.25rem] xl:text-[2rem] capitalize text-[#FCE2B0] leading-[100%] mb-4 lg:mb-[3rem] text-center"
            >
              {loading
                ? "..."
                : !!slugData?.eventBySlug && !!slugData?.eventBySlug?.hash_tag
                ? slugData?.eventBySlug?.hash_tag
                : ""}
            </motion.p>

            {/* <motion.p
              initial={{ opacity: 0, y: 30 }}
              whileInView={{
                opacity: 1,
                y: 0,
                transition: {
                  duration: 1,
                  ease: [0.79, 0.14, 0.15, 0.86],
                },
              }}
              className="font-light font-ebGaramond text-base sm:text-lg md:text-xl lg:text-[1.25rem] xl:text-[2rem] italic text-[#FCE2B0] leading-[100%] mb-4 lg:mb-[3rem] text-center"
            >
              {loading
                ? "..."
                : !!slugData?.eventBySlug &&
                  !!slugData?.eventBySlug?.welcome_msg
                ? slugData?.eventBySlug?.welcome_msg
                : ""}
            </motion.p> */}
          </div>
        </div>
      </div>

      {/* Image Section - Second on mobile, first on desktop */}
      <div className="flex-1 h-1/2 lg:h-full order-2 lg:order-1 lg:hidden">
        <motion.div
          initial={{ scale: 1 }}
          animate={{
            scale: 1.0,
            transition: {
              delay: 0.3,
              duration: 0.8,
              ease: [0.79, 0.14, 0.15, 0.86],
            },
          }}
          className="relative top-0 bottom-0 right-0 left-0 w-full h-full"
        >
          <Image
            // placeholder="blur"
            loading="eager"
            layout="fill"
            // blurDataURL={`data:image/svg+xml;base64,${toBase64(
            // shimmer(700, 475)
            // )}`}
            src={
              !!heroImageData.getHeroImage ? heroImageData.getHeroImage : image
            }
            alt="gallery-image"
            className="object-cover object-top lg:object-center"
          />
        </motion.div>
      </div>
    </div>
  );
};

export default Hero;
